module.exports = __webpack_public_path__ + "img/SMSC15107-min.c6d7c7b9.png";